import { defineComponent } from "vue";
import { p as pick_1 } from "../../../../../vendor-b303cd6e.mjs";
import { u as useAlignProps, a as useAlign } from "../../../../composables/useAlign-c67f8aff.mjs";
import { u as useComponentPresetProp } from "../../../../composables/useComponentPreset-0dfbd395.mjs";
import { u as useBem } from "../../../../composables/useBem-a19cd502.mjs";
const _sfc_main = defineComponent({
  name: "VaCardActions",
  props: {
    ...useAlignProps,
    ...useComponentPresetProp
  },
  setup(props) {
    const { alignComputed } = useAlign(props);
    const classComputed = useBem("va-card__actions", () => ({
      ...pick_1(props, ["vertical"])
    }));
    return {
      classComputed,
      alignComputed
    };
  }
});
export {
  _sfc_main as _
};
//# sourceMappingURL=VaCardActions.vue_vue_type_script_lang-b9f7c23e.mjs.map
